export default __webpack_public_path__ + "static/media/pszczola.b67882bd.svg";